// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__zd-uY"};